import { z, ZodString } from 'zod';
import { extendZodWithOpenApi } from '@asteasolutions/zod-to-openapi';
import { parsePhoneNumberFromString } from 'libphonenumber-js/min';
const DEFAULT_COMMON_MSG = 'Invalid email address';
const DEFAULT_MASKED_MSG = 'Expected masked email like n***@domain.com';
const DEFAULT_PHONE_MESSAGE = 'Invalid phone number';
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-expect-error
ZodString.prototype.commonEmail = function (message = DEFAULT_COMMON_MSG) {
    return this.trim().toLowerCase().max(150).email(message);
};
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-expect-error
ZodString.prototype.maskedEmail = function (message = DEFAULT_MASKED_MSG) {
    return this.regex(/^[A-Za-z0-9._%+-]+?\*{3}@[A-Za-z0-9-]+(?:\.[A-Za-z0-9-]+)+$/, message);
};
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-expect-error
ZodString.prototype.emailOrMasked = function (message) {
    return z.union([
        this.commonEmail(message !== null && message !== void 0 ? message : DEFAULT_COMMON_MSG),
        this.maskedEmail(message !== null && message !== void 0 ? message : DEFAULT_MASKED_MSG),
    ]);
};
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-expect-error
ZodString.prototype.phoneNumber = function (message = DEFAULT_PHONE_MESSAGE, opts = {}) {
    return this.trim().refine((value) => {
        if (opts.emptyStringAllowed && value === '') {
            return true;
        }
        if (!value.startsWith('+')) {
            return false;
        }
        try {
            const phone = parsePhoneNumberFromString(value);
            if (!phone) {
                return false;
            }
            if (!phone.isPossible()) {
                return false;
            }
            if (opts.allowedCountries && phone.country && !opts.allowedCountries.includes(phone.country)) {
                return false;
            }
            return !(opts.allowExtensions === false && phone.ext);
        }
        catch (_a) {
            return false;
        }
    }, { message });
};
extendZodWithOpenApi(z);
export { z };
